(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationDuplicateTravel',
	};

	var $form;

	var _checkComments,
	    _existingPrimaryRecommendedTravelers,
	    _existingReservationRecommendedTravelers,
	    _newPrimaryRecommendedTraveler;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$form = $(form.element);

		Adzuki.Erez.SearchAddTraveler.init(form.name);

		// Toggle new/existing reservation
		$form.find('.new-existing-reservation').on('change', function change(e) {
			if ($(this).val() === 'new') {
				$form.find('.existing-reservation').addClass('hidden');
				$form.find('.new-reservation').removeClass('hidden');
			} else {
				$form.find('.new-reservation').addClass('hidden');
				$form.find('.existing-reservation').removeClass('hidden');
			}
		});

		// Update recommended travelers when toggling between existing and new reservation
		$form.find('.new-existing-reservation').on('change', function change(e) {
			if ($(e.target).val() === 'new') {
				if ($('#client-type-existing-0').is(':checked')) {
					_existingPrimaryRecommendedTravelers();
				} else {
					_newPrimaryRecommendedTraveler();
				}
			} else {
				_existingReservationRecommendedTravelers();
			}
		});

		// Update recommended travelers when toggling between existing and new primary client
		$form.find('.new-or-existing').on('change', function change(e) {
			if ($(e.target).val() === 'existing') {
				_existingPrimaryRecommendedTravelers();
			} else {
				_newPrimaryRecommendedTraveler();
			}
		});

		// Update recommended travelers when existing primary client is selected
		$form.find('.reservation-typeahead').on('ta.set-hidden', function setHidden(e) {
			_existingReservationRecommendedTravelers();
		});

		// Update recommended travelers when existing primary client is reset
		$form.find('.reservation-typeahead').on('ta.reset', function reset(e) {
			_existingReservationRecommendedTravelers();
		});

		// Update recommended travelers when existing primary client is selected
		$('#reservationduplicatetravel-neworexistingclient-0-existingclient-existing_client_name').on('ta.set-hidden', function setHidden(e) {
			_existingPrimaryRecommendedTravelers();
		});

		// Update recommended travelers when existing primary client is reset
		$('#reservationduplicatetravel-neworexistingclient-0-existingclient-existing_client_name').on('ta.reset', function reset(e) {
			_existingPrimaryRecommendedTravelers();
		});

		// Update recommended travelers as first name, last name and DOB are modified
		$('#reservationduplicatetravel-neworexistingclient-0-newclient-new_client_first_name').on('keyup', function keyup(e) {
			_newPrimaryRecommendedTraveler();
		});

		$('#reservationduplicatetravel-neworexistingclient-0-newclient-new_client_last_name').on('keyup', function keyup(e) {
			_newPrimaryRecommendedTraveler();
		});

		$('#reservationduplicatetravel-neworexistingclient-0-newclient-new_client_birthday').on('dp.change', function dateChange(e) {
			_newPrimaryRecommendedTraveler();
		});

		// Toggle client opportunity typeahead
		$form.find('.tie-to-client-opportunity').on('change', function change(e) {
			$form.find('.client-opportunity').toggleClass('hidden');
		});

		// Client opportunity typeahead logic
		Adzuki.Typeahead(
			'#reservationduplicatetravel-client_opportunity_search',
			'/ClientOpportunities/typeaheadSearch',
			function select(item, $self, typeahead) {
				$self.val(item.name);

				typeahead.setHiddenValue(item.id);
			},
			function template(item) {
				return item.name;
			}
		);

		// Toggle vendor logic
		$form.find('.dr-toggle-vendor').on('change', function change(e) {
			var $reservation_vendor = $('#reservation-vendor-' + $(this).data('reservation-vendor-id'));

			if (this.checked) {
				$reservation_vendor.find('.dr-vendor:not(".dr-checkbox.dr-required-component"):not(".dr-confirmation-number.dr-pricing-only"):not(".dr-booking-date.dr-pricing-only")').prop('disabled', false);
				$reservation_vendor.find('.dr-checkbox').prop('checked', true);
				$reservation_vendor.find('.dr-hidden').val('1');
			} else {
				$reservation_vendor.find('.dr-hidden').val('0');
				$reservation_vendor.find('.dr-checkbox').prop('checked', false);
				$reservation_vendor.find('.dr-vendor').prop('disabled', true);
			}

			_checkComments();
		});

		// Toggle all components for vendor logic
		$form.find('.dr-toggle-components').on('change', function change(e) {
			var $reservation_vendor = $('#reservation-vendor-' + $(this).data('reservation-vendor-id'));

			if (this.checked) {
				$reservation_vendor.find('.dr-checkbox').prop('checked', true);
			} else {
				$reservation_vendor.find('.dr-checkbox:not(".dr-required-component")').prop('checked', false);
			}

			_checkComments();
		});

		// Toggle individual components for vendor logic
		$form.find('.dr-component.dr-checkbox').on('change', function change(e) {
			var $reservation_vendor  = $('#reservation-vendor-' + $(this).data('reservation-vendor-id')),
			    $confirmation_number = $(this).parent().parent().find('.dr-confirmation-number'),
			    $cabin_number        = $(this).parent().parent().find('.dr-cabin-number'),
			    $booking_date        = $(this).parent().parent().find('.dr-booking-date');

			if (this.checked) {
				// confirmation number
				if (!$confirmation_number.hasClass('dr-pricing-only')) {
					$confirmation_number.prop('disabled', false);
				}

				// cabin number
				if ($cabin_number) {
					if (!$cabin_number.hasClass('dr-pricing-only')) {
						$cabin_number.prop('disabled', false);
					}
				}

				// booking date
				if (!$booking_date.hasClass('dr-pricing-only')) {
					$booking_date.prop('disabled', false);
				}

				if ($reservation_vendor.find('.dr-component.dr-checkbox:checked').length === $reservation_vendor.find('.dr-component.dr-checkbox').length) {
					$reservation_vendor.find('.dr-toggle-components').prop('checked', true);
				}
			} else {
				// confirmation number
				if (!$confirmation_number.hasClass('dr-pricing-only')) {
					$confirmation_number.prop('disabled', true);
				}

				// cabin number
				if ($cabin_number) {
					if (!$cabin_number.hasClass('dr-pricing-only')) {
						$cabin_number.prop('disabled', true);
					}
				}

				// booking date
				if (!$booking_date.hasClass('dr-pricing-only')) {
					$booking_date.prop('disabled', true);
				}

				$reservation_vendor.find('.dr-toggle-components').prop('checked', false);
			}

			_checkComments();
		});

		// Confirmation number copying logic
		$form.find('.dr-confirmation-number.dr-required-component').on('keyup', function change(e) {
			var $required_confirmation_number = $(this),
			    $reservation_vendor  = $('#reservation-vendor-' + $required_confirmation_number.data('reservation-vendor-id'));

			if (typeof $required_confirmation_number.data('old-value') === 'undefined') {
				$required_confirmation_number.data('old-value', '');
			}

			$reservation_vendor.find('.dr-confirmation-number:not(".dr-required-component")').each(function iterator(i, confirmation_number) {
				var $confirmation_number = $(confirmation_number);

				if ($confirmation_number.val() === $required_confirmation_number.data('old-value')) {
					$confirmation_number.val($required_confirmation_number.val());
				}
			});

			$required_confirmation_number.data('old-value', $required_confirmation_number.val());
		});

		// Booking date copying logic
		$form.find('.dr-booking-date.dr-required-component').on('dp.change', function dateChange(e) {
			var $required_booking_date        = $(this),
			    $required_booking_date_hidden = $(this).closest('span').find('input[type=hidden]'),
			    $reservation_vendor           = $('#reservation-vendor-' + $required_booking_date.data('reservation-vendor-id'));

			if (typeof $required_booking_date.data('old-value') === 'undefined') {
				$required_booking_date.data('old-value', '');
			}

			$reservation_vendor.find('.dr-booking-date:not(".dr-required-component")').each(function iterator(i, booking_date) {
				var $booking_date        = $(booking_date),
				    $booking_date_hidden = $(booking_date).closest('span').find('input[type=hidden]');

				if ($booking_date_hidden.val() === $required_booking_date.data('old-value')) {
					$booking_date.val($required_booking_date.val());
					$booking_date_hidden.val($required_booking_date_hidden.val());
				}
			});

			$required_booking_date.data('old-value', $required_booking_date_hidden.val());
		});

		// Modify hidden return_to_duplication field when checkbox at bottom is checked/unchecked
		$('.duplicate-travel-return').on('change', function change(e) {
			var $target = $(this);

			if ($target.is(':checked')) {
				$('#reservationduplicatetravel-return_to_duplication').val('1');
			} else {
				$('#reservationduplicatetravel-return_to_duplication').val('0');
			}
		});

		// Submit form when Duplicate Selected Components is clicked
		$('.duplicate-travel-submit').on('click', function click(e) {
			var $target = $(e.target);

			$('.selected-travelers-box').removeClass('error');
			$target.addClass('disabled');
			$target.next().css('visibility', 'visible');
			$form.submit();
		});

		_checkComments();
	};

	form.success = function success(response)
	{
		var $duplicate_travel_submit = $('.duplicate-travel-submit');

		// this is used if a new client is added and the agent entered an email address that is a dupe of another client in their franchise
		if (response['status'] === 'confirmation_prompt') {
			Adzuki.Erez.ClientDuplicateEmail.confirm(response, form.name);

			$duplicate_travel_submit.next().css('visibility', 'hidden');
			$duplicate_travel_submit.removeClass('disabled');

			return false;
		}

		if (!Adzuki.Form.hasError(response)) {
			window.location.href = response['data'];
			return true;
		}

		if (response['status'] === 'validation_error') {
			$.each(response['data'], function iterator(i, error_data) {
				if ('errors' in error_data && error_data['errors'][0].substr(0, 19) === 'Selected Travelers ') {
					$('.selected-travelers-box').addClass('error');

					return false;
				}
			});
		}

		$duplicate_travel_submit.next().css('visibility', 'hidden');
		$duplicate_travel_submit.removeClass('disabled');

		return false;
	};

	_checkComments = function _checkComments()
	{
		var reservation_id = $('#reservationduplicatetravel-reservation_id').val(),
		    ajax_url       = '/Reservations/checkComments/' + reservation_id;

		$form.find('.dr-component.dr-checkbox:checked').each(function iterator(i, checkbox) {
			ajax_url += '/' + $(checkbox).data('component-key');
		});

		Adzuki.Ajax.get(ajax_url).then(function success(comment_status) {
			var show_comments = false;

			if ($('#reservationduplicatetravel-duplication_type').val() === 'reservation' && comment_status['reservation'] > 0) {
				$form.find('.reservation-comments').removeClass('hidden');

				show_comments = true;
			} else {
				$form.find('.reservation-comments').addClass('hidden');
			}

			if (comment_status['vendor'] > 0) {
				$form.find('.vendor-comments').removeClass('hidden');

				show_comments = true;
			} else {
				$form.find('.vendor-comments').addClass('hidden');
			}

			if (show_comments) {
				$form.find('.comments').removeClass('hidden');
			} else {
				$form.find('.comments').addClass('hidden');
			}
		});
	};

	_existingPrimaryRecommendedTravelers = function _existingPrimaryRecommendedTravelers()
	{
		var client_id = $('#reservationduplicatetravel-neworexistingclient-0-existingclient-existing_client_id').val();

		// eslint-disable-next-line no-negated-condition
		if (client_id !== '') {
			Adzuki.Ajax.get('/Reservations/getRecommendedTravelers/client/' + client_id).then(function success(recommended_travelers) {
				Adzuki.Erez.SearchAddTraveler.buildRecommendedTravelers(recommended_travelers);
			});
		} else {
			Adzuki.Erez.SearchAddTraveler.resetRecommendedTravelers();
		}
	};

	_existingReservationRecommendedTravelers = function _existingReservationRecommendedTravelers()
	{
		var reservation_id = $('#reservationduplicatetravel-destination_reservation_id').val();

		// eslint-disable-next-line no-negated-condition
		if (reservation_id !== '') {
			Adzuki.Ajax.get('/Reservations/getRecommendedTravelers/reservation/' + reservation_id).then(function success(recommended_travelers) {
				Adzuki.Erez.SearchAddTraveler.buildRecommendedTravelers(recommended_travelers);
			});
		} else {
			Adzuki.Erez.SearchAddTraveler.resetRecommendedTravelers();
		}
	};

	_newPrimaryRecommendedTraveler = function _newPrimaryRecommendedTraveler()
	{
		var first_name            = $('#reservationduplicatetravel-neworexistingclient-0-newclient-new_client_first_name').val(),
		    last_name             = $('#reservationduplicatetravel-neworexistingclient-0-newclient-new_client_last_name').val(),
		    date_of_birth         = $('#reservationduplicatetravel-neworexistingclient-0-newclient-new_client_birthday_hidden').val(),
		    recommended_travelers = [],
		    name,
		    dob_moment,
		    now_moment;

		if (first_name !== '' && last_name !== '') {
			name = first_name + ' ' + last_name;

			if (date_of_birth !== '') {
				dob_moment = moment(date_of_birth);
				now_moment = moment();

				name += ' (Age: ' + now_moment.diff(dob_moment, 'years') + ')';
			}

			recommended_travelers[0] = {
				id            : 0,
				name          : name,
				primary_client: 1,
			};

			Adzuki.Erez.SearchAddTraveler.buildRecommendedTravelers(recommended_travelers);
		} else {
			Adzuki.Erez.SearchAddTraveler.resetRecommendedTravelers();
		}
	};

}(jQuery, window.Adzuki || {}));
